import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import AuthCallback from "./views/AuthCallback.vue";
import { vuexOidcCreateRouterMiddleware } from "vuex-oidc";
import store from "./store/store";
import Analytics from "./Analytics";

Vue.use(Router);

const router = new Router({
	mode: "history",
	base: process.env.BASE_URL,
	routes: [
		{
			path: "/",
			name: "home",
			component: Home,
			meta: {
				isPublic: true
			}
		},
		{
			path: "/auth-callback", // Needs to match redirect_uri in you oidcSettings
			name: "authCallback",
			component: AuthCallback,
			meta: {
				isOidcCallback: true,
				isPublic: true
			}
		},
		{
			path: "/ip",
			name: "ip",
			component: Home,
			meta: {
				isPublic: true
			}
		},
		{
			path: "/ip/:address",
			name: "ip-address",
			component: Home,
			meta: {
				isPublic: true
			}
		},
		{
			path: "/ip/:address/:bits",
			name: "ip-address-bits",
			component: Home,
			meta: {
				isPublic: true
			}
		},
		{
			path: "/autnum",
			name: "autnum",
			component: Home,
			meta: {
				isPublic: true
			}
		},
		{
			path: "/autnum/:address",
			name: "autnum-address",
			component: Home,
			meta: {
				isPublic: true
			}
		},
		// for handle search ip in autnum
		{
			path: "/autnum/:address/:bits",
			name: "autnum-address-bits",
			component: Home,
			meta: {
				isPublic: true
			}
		},
		{
			path: "/entity",
			name: "entity",
			component: Home,
			meta: {
				isPublic: true
			}
		},
		{
			path: "/entity/:address",
			name: "entity-address",
			component: Home,
			meta: {
				isPublic: true
			}
		},
		// for handle search ip in entity
		{
			path: "/entity/:address/:bits",
			name: "entity-address-bits",
			component: Home,
			meta: {
				isPublic: true
			}
		},
		{
			path: "/about",
			name: "about",
			component: () => import("./views/About.vue"),
			meta: {
				isPublic: true
			}
		},
		{
			path: "/help",
			name: "help",
			component: () => import("./views/Help.vue"),
			meta: {
				isPublic: true
			}
		},
		// leave this at the bottom, also, this should be a temporary solution to handle 404 request
		{
			path: "/404",
			name: "404",
			component: () => import("./views/404NotFound.vue"),
			meta: {
				isPublic: true
			}
		},
		{ path: "*", redirect: "/404" }
	]
});

router.beforeEach(vuexOidcCreateRouterMiddleware(store, "authStore"));

Analytics.trackPageView({ pageURL: router.currentRoute.path });

router.afterEach(to => {
	Analytics.trackPageView({ pageURL: to.path });
});

export default router;
